import { render, staticRenderFns } from "./DailyInventory.vue?vue&type=template&id=687f4cdc&scoped=true&"
import script from "./DailyInventory.vue?vue&type=script&lang=js&"
export * from "./DailyInventory.vue?vue&type=script&lang=js&"
import style0 from "./DailyInventory.vue?vue&type=style&index=0&id=687f4cdc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687f4cdc",
  null
  
)

export default component.exports